export function WaitForElementToDisplay(selector: string, time: number, callback: Function) {
    if (document.querySelector(selector) != null) {
        callback();
        return;
    }
    else {
        setTimeout(function () {
            WaitForElementToDisplay(selector, time, callback);
        }, time);
    }
}